// About page content — strategic repositioning (approved structure, 7 sections).
export const WHY_WORDS = [
    "COST UNCERTAINTY",
    "COMPLEX INFORMATION",
    "QUOTATION TRANSPARENCY",
    "COMPLIANCE & DECISIONS",
];

export const STATUS_LABELS = {
    pilot: "IN THE PILOT",
    dev: "IN DEVELOPMENT",
    planned: "PLANNED",
};

export const CAPABILITIES = [
    {
        n: "01",
        title: "Architectural Drawing Intelligence",
        copy: "Helping homeowners interpret architectural information and better understand the design and construction requirements represented in their plans.",
        status: "pilot",
    },
    {
        n: "02",
        title: "BOQ & Cost Intelligence",
        copy: "Transforming available construction information into structured quantities, Bills of Quantities and cost estimates, with assumptions and supporting information stated.",
        status: "pilot",
    },
    {
        n: "03",
        title: "Contractor Quote Analysis",
        copy: "Helping homeowners examine contractor quotations, compare pricing and identify differences, omissions and items requiring clarification.",
        status: "pilot",
    },
    {
        n: "04",
        title: "Materials Intelligence",
        copy: "Supporting informed material decisions through construction information, material specifications and appropriately sourced pricing information.",
        status: "pilot",
    },
    {
        n: "05",
        title: "Structural Intelligence",
        copy: "Helping users understand relevant structural documentation, quantities and coordination considerations, subject to appropriate professional review.",
        status: "dev",
    },
    {
        n: "06",
        title: "Home Vision & 3D Visualisation",
        copy: "Helping homeowners explore their architectural designs through digital visualisation and interior design possibilities.",
        status: "pilot",
    },
    {
        n: "07",
        title: "Compliance Intelligence",
        copy: "Making relevant building requirements, regulatory considerations and documentation guidance easier to understand.",
        status: "dev",
    },
    {
        n: "08",
        title: "Green & Energy Intelligence",
        copy: "Introducing sustainability, energy efficiency and environmentally conscious construction considerations into residential building decisions.",
        status: "planned",
        sustainability: true,
    },
    {
        n: "09",
        title: "Risk & Budget Intelligence",
        copy: "Helping homeowners understand potential cost pressures, project uncertainties, assumptions and financial implications.",
        status: "dev",
    },
];

export const ENGINE_STAGES = [
    {
        n: "E.01",
        title: "ARCHITECTURAL PLANS",
        copy: "Your plans and project information enter the platform.",
    },
    {
        n: "E.02",
        title: "CONSTRUCTION INTELLIGENCE",
        copy: "Information is interpreted and connected across the building journey.",
        engine: true,
    },
    {
        n: "E.03",
        title: "BOQ & COST INTELLIGENCE",
        copy: "Quantities and cost estimates take shape, with assumptions stated.",
    },
    {
        n: "E.04",
        title: "DECISION SUPPORT",
        copy: "Quotations, compliance and budget choices become clearer.",
    },
    {
        n: "E.05",
        title: "HOME VISION",
        copy: "Your design comes to life as an explorable visual concept.",
    },
];

export const ENGINE_LINKS = [
    "PLANS INFORM QUANTITIES",
    "QUANTITIES INFORM COSTS",
    "COSTS INFORM DECISIONS",
    "DECISIONS INFORM VISION",
];

export const PRINCIPLES = [
    {
        title: "CLARITY",
        copy: "We make complex construction information easier to understand, helping homeowners approach important decisions with greater confidence.",
        icon: "Eye",
    },
    {
        title: "TRANSPARENCY",
        copy: "We believe homeowners should have better visibility into quantities, estimates, costs, assumptions and uncertainties.",
        icon: "ScanSearch",
    },
    {
        title: "INTELLIGENCE",
        copy: "We connect artificial intelligence with structured construction knowledge to support more informed decisions.",
        icon: "Layers",
    },
    {
        title: "RESPONSIBILITY",
        copy: "We recognise that construction decisions carry financial, technical and regulatory consequences. Our platform must communicate uncertainty, limitations and the importance of appropriate professional review.",
        icon: "ShieldCheck",
    },
];

export const AI_TRANSPARENCY_NOTE =
    "BuildEase uses AI to support construction insights. AI-generated information may contain errors and should be reviewed where appropriate.";
